<section class="section-recovery-password w-100 d-flex background-grey justify-content-center align-items-center">
    <div class="password password-container d-flex h-100 p-4">
        <app-back-button url="./login" class="back-button">BACK LOGIN</app-back-button>
        <mat-card appearance="outlined" class="sticky-top-10 password-form-container px-3 px-sm-5 py-5">
            <div class="d-flex justify-content-center password-logo">
                <app-facility-logo class="logo" [width]="widthLogo" [height]="heightLogo" />
            </div>
            <h1 class="foreground-primary-default mat-headline-4 text-center m-0 mt-3 mb-1">Forgot your password?</h1>
            <p class="subheading mat-subtitle-1">Please, enter your email address to restart your password.</p>
            <form [formGroup]="formRecoveryPassword" (submit)="recoveryPassword($event, formRecoveryPassword)">
                <mat-form-field class="col-12">
                    <mat-label>Email</mat-label>
                    <input
                        type="email"
                        formControlName="email"
                        matInput
                        placeholder="Enter email"
                        id="email-recovery"
                    />
                    <mat-error>
                        <app-field-error [field]="'email'" [messageList]="formErrors['email']" />
                    </mat-error>
                </mat-form-field>
                <button
                    matButton="filled"
                    type="submit"
                    class="btn-reset w-100 mt-2"
                    [disabled]="formRecoveryPassword.invalid"
                    color="primary"
                >
                    RESET PASSWORD
                </button>
            </form>
            <p class="subheading mat-subtitle-1 mt-4">
                Do you already have an account?
                <button (click)="signIn()" type="button" mat-button color="primary" class="primary link mat-subtitle-2">
                    Sign in
                </button>
            </p>
        </mat-card>
    </div>
</section>
